import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { isValidPastDate } from '@/functions/validators';
import { get, sync } from 'vuex-pathify';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'LocationCheckIn',
  components: {
    FibFindOutMore: require('@/components/FindOutMore').default,
    FibLocationPicker: require('@/components/LocationPicker').default
  },
  data: function data() {
    return {
      isRestaurant: true,
      location: 'Thaikhun Guildford',
      slide: '1'
    };
  },
  computed: {
    branchDetails: sync('config/branchDetails'),
    branches: sync('checkIn/branches'),
    branchId: sync('config/branchId'),
    logoRestaurant: get('theme/logo'),
    returnedLocation: sync('checkIn/returnedLocation'),
    showAboutVisit: get('checkIn/showAboutVisit'),
    visitDetails: get('checkIn/getVisitDetails'),
    bgImage: function bgImage() {
      return this.$store.getters['theme/bgImage'];
    },
    urlParams: sync('checkIn/urlParams'),
    headerStyles: function headerStyles() {
      return {
        background: "linear-gradient(130deg, ".concat(this.theme.gradientColorStart, ", ").concat(this.theme.gradientColorStart, " 20%, ").concat(this.theme.gradientColorEnd, ")")
      };
    },
    logoStyle: function logoStyle() {
      if (this.isRestaurant) {
        return {
          width: '50px',
          position: 'absolute',
          left: '0',
          top: '0'
        };
      }

      return '90px';
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  mounted: function mounted() {
    this.branchDetails = null;
    this.branches = null;
    this.branchId = null;
  },
  methods: {
    onCheckIn: function onCheckIn() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$urlParams;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // try to get user location info
                // set loading state
                _this.$q.loading.show({
                  message: _this.$t('common.misc.loading')
                });

                _context.next = 3;
                return navigator.geolocation.getCurrentPosition(function (location) {
                  _this.returnedLocation = location;
                }, function (e) {
                  Logger.error('geolocationError', e);
                });

              case 3:
                _context.next = 5;
                return _this.$store.dispatch('checkIn/fetchBranches', (_this$urlParams = _this.urlParams) === null || _this$urlParams === void 0 ? void 0 : _this$urlParams.slug);

              case 5:
                // remove loading state
                _this.$q.loading.hide();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onLocationSelected: function onLocationSelected(branch) {
      if (!branch || !branch.id) {
        return;
      } // set selected branch in store


      this.branchId = branch.id;
      this.branchDetails = branch;
      this.onSubmit();
    },
    onSubmit: function onSubmit() {
      var _this$visitDetails;

      // if location returned, check how many, else continue
      if (Array.isArray(this.returnedLocation) && this.returnedLocation.length >= 1) {
        // check how many locations were returned
        if (this.returnedLocation.length === 1) {
          // one location returned, redirect to guest table number entry and return
          Logger.debug('one location returned, redirecting to guest table number entry');
          this.$router.push('/check_in/guest_table_number_entry');
          return;
        } else {
          // multiple locations returned, redirect to list nearby locations and return
          Logger.debug('multiple locations returned, redirecting to list nearby locations');
          this.$router.push('/check_in/list_nearby_locations');
          return;
        }
      }

      Logger.debug('no location returned'); // if branch details NOT stored, redirect to find venue and return

      if (!this.branchDetails) {
        Logger.debug('branch details NOT stored, redirecting to find venue');
        this.$router.push('/check_in/find_venue');
        return;
      }

      Logger.debug('branch details stored'); // if visit details stored and valid, redirect to questions and return

      var datetime = cloneDeep((_this$visitDetails = this.visitDetails) === null || _this$visitDetails === void 0 ? void 0 : _this$visitDetails.datetime);
      var visitDetailsValid = isValidPastDate(datetime);

      if (visitDetailsValid) {
        Logger.debug('valid visit details stored, redirecting to questions');
        this.$router.push('/questions');
        return;
      }

      Logger.debug('valid visit details NOT stored');

      if (this.showAboutVisit) {
        Logger.debug('config set to show about visit, redirecting to about visit');
        this.$router.push('/check_in/about_visit');
        return;
      } else {
        // config set to NOT show about visit, redirect to questions and return
        Logger.debug('config set to NOT show about visit, redirecting to questions');
        this.$router.push('/questions');
        return;
      }
    }
  }
};